module.exports = __webpack_public_path__ + "static/media/header-vragen-background.09899882.jpg";